// extracted by mini-css-extract-plugin
export default {"wordLogo":"SimplifiedMobileContainer_wordLogo__T8wO8","topSectionContainer":"SimplifiedMobileContainer_topSectionContainer__A0BXr"};